module.exports = __webpack_public_path__ + "img/bottom_tree_005.f14eefe1.svg";